module.exports = __webpack_public_path__ + "media/images/icons/SVG/011-ddedb1ddd7753349a7e4b4794dd7d1ea.svg";